var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selectSalutation",attrs:{"label":_vm.$localize('SelectSalutation.label'),"hint":_vm.$localize('SelectSalutation.hint'),"items":_vm.items,"value":_vm.value,"prepend-icon":"mdi-gender-male-female","autofocus":_vm.autofocus,"clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }